import { padronesEnum } from 'views/Tramites/GPM/enums';
import expedienteLicenciaFuncionamiento from 'views/Tramites/GPM/configsPadrones/expedienteLicenciaFuncionamiento';
import ciudadano from 'views/Tramites/GPM/configsPadrones/ciudadano';
import empresas from 'views/Tramites/GPM/configsPadrones/empresas';
import predios from 'views/Tramites/GPM/configsPadrones/predios';
import vehiculos from 'views/Tramites/GPM/configsPadrones/vehiculos';
import derivadoEmpresaBase from 'views/Tramites/GPM/configsPadrones/derivadoEmpresaBase';
import cedular from 'views/Tramites/GPM/configsPadrones/cedular';
import alcohol from 'views/Tramites/GPM/configsPadrones/alcohol';
import contribuyente from 'views/Tramites/GPM/configsPadrones/contribuyente';
import motocicleta from 'views/Tramites/GPM/configsPadrones/motocicleta';
import remolque from 'views/Tramites/GPM/configsPadrones/remolque';
import policiasEspeciales from 'views/Tramites/GPM/configsPadrones/policiasEspeciales';
import expedienteComercio from 'views/Tramites/GPM/configsPadrones/expedienteComercio';
import mercado from 'views/Tramites/GPM/configsPadrones/mercado';
import zonaExclusiva from 'views/Tramites/GPM/configsPadrones/zonaExclusiva';
import expedienteAnuncio from 'views/Tramites/GPM/configsPadrones/expedienteAnuncio';
import multas from 'views/Tramites/GPM/configsPadrones/multas';
import nomina from 'views/Tramites/GPM/configsPadrones/nomina';
import expedienteDeModulo from 'views/Tramites/GPM/configsPadrones/expedienteDeModulo';

export const sharedForbiddenProps = [
  'entidad',
  'estados_globales',
  'direccion',
];

// Para prevenir errores al intentar accede a las props de un padrón que aun no se añade soporte
const keysAsEmptyObjects = Object.fromEntries(Object.values(padronesEnum).map((p) => [p, {}]));
const keysAsEmptyArray = Object.fromEntries(Object.values(padronesEnum).map((p) => [p, []]));

export const configs = {
  ...keysAsEmptyObjects,
  [padronesEnum.CIUDADANO]: ciudadano.configs,
  [padronesEnum.EMPRESA]: empresas.configs,
  [padronesEnum.PREDIO]: predios.configs,
  [padronesEnum.VEHICULO]: vehiculos.configs,
  [padronesEnum.HOSPEDAJE]: derivadoEmpresaBase.configs,
  [padronesEnum.ARRENDAMIENTO]: derivadoEmpresaBase.configs,
  [padronesEnum.NOMINA]: nomina.configs,
  [padronesEnum.ALCOHOL]: alcohol.configs,
  [padronesEnum.CEDULAR]: cedular.configs,
  [padronesEnum.JUEGO_DE_AZAR]: derivadoEmpresaBase.configs,
  [padronesEnum.NOTARIO]: derivadoEmpresaBase.configs,
  [padronesEnum.CASA_DE_EMPENIO]: derivadoEmpresaBase.configs,
  [padronesEnum.AGENCIA]: derivadoEmpresaBase.configs,
  [padronesEnum.CONTRIBUYENTE]: contribuyente.configs,
  [padronesEnum.MOTOCICLETA]: motocicleta.configs,
  [padronesEnum.REMOLQUE]: remolque.configs,
  [padronesEnum.POLICIA_ESPECIAL]: policiasEspeciales.configs,
  // [padronesEnum.INFRACCIONES]: infracciones.configs,
  [padronesEnum.COMERCIO_INFORMAL]: expedienteComercio.configs,
  [padronesEnum.MERCADO]: mercado.configs,
  [padronesEnum.EXPEDIENTE_LICENCIA_FUNCIONAMIENTO]: expedienteLicenciaFuncionamiento.configs,
  [padronesEnum.ZONA_EXCLUSIVA]: zonaExclusiva.configs,
  [padronesEnum.EXPEDIENTE_DE_ANUNCIO]: expedienteAnuncio.configs,
  [padronesEnum.MULTAS]: multas.configs,
  [padronesEnum.VENDEDOR_DE_ALCOHOLES]: derivadoEmpresaBase.configs,
  [padronesEnum.RETENEDOR_DE_CEDULA]: derivadoEmpresaBase.configs,
  [padronesEnum.RETENEDOR_DE_NOMINA]: derivadoEmpresaBase.configs,
  [padronesEnum.MODULOS]: expedienteDeModulo.configs,
};

export const forbiddenProps = {
  ...keysAsEmptyArray,
  [padronesEnum.CIUDADANO]: ciudadano.forbiddenProps,
  [padronesEnum.EMPRESA]: empresas.forbiddenProps,
  [padronesEnum.PREDIO]: predios.forbiddenProps,
  [padronesEnum.VEHICULO]: vehiculos.forbiddenProps,
  [padronesEnum.HOSPEDAJE]: derivadoEmpresaBase.forbiddenProps,
  [padronesEnum.ARRENDAMIENTO]: derivadoEmpresaBase.forbiddenProps,
  [padronesEnum.NOMINA]: nomina.forbiddenProps,
  [padronesEnum.ALCOHOL]: alcohol.forbiddenProps,
  [padronesEnum.CEDULAR]: cedular.forbiddenProps,
  [padronesEnum.JUEGO_DE_AZAR]: derivadoEmpresaBase.forbiddenProps,
  [padronesEnum.NOTARIO]: derivadoEmpresaBase.forbiddenProps,
  [padronesEnum.CASA_DE_EMPENIO]: derivadoEmpresaBase.forbiddenProps,
  [padronesEnum.AGENCIA]: derivadoEmpresaBase.forbiddenProps,
  [padronesEnum.CONTRIBUYENTE]: contribuyente.forbiddenProps,
  [padronesEnum.MOTOCICLETA]: motocicleta.forbiddenProps,
  [padronesEnum.REMOLQUE]: remolque.forbiddenProps,
  [padronesEnum.POLICIA_ESPECIAL]: policiasEspeciales.forbiddenProps,
  // [padronesEnum.INFRACCIONES]: infracciones.forbiddenProps,
  [padronesEnum.COMERCIO_INFORMAL]: expedienteComercio.forbiddenProps,
  [padronesEnum.MERCADO]: mercado.forbiddenProps,
  [padronesEnum.EXPEDIENTE_LICENCIA_FUNCIONAMIENTO]: expedienteLicenciaFuncionamiento
    .forbiddenProps,
  [padronesEnum.ZONA_EXCLUSIVA]: zonaExclusiva.forbiddenProps,
  [padronesEnum.EXPEDIENTE_DE_ANUNCIO]: expedienteAnuncio.forbiddenProps,
  [padronesEnum.MULTAS]: multas.forbiddenProps,
  [padronesEnum.VENDEDOR_DE_ALCOHOLES]: derivadoEmpresaBase.forbiddenProps,
  [padronesEnum.RETENEDOR_DE_CEDULA]: derivadoEmpresaBase.forbiddenProps,
  [padronesEnum.RETENEDOR_DE_NOMINA]: derivadoEmpresaBase.forbiddenProps,
  [padronesEnum.MODULOS]: expedienteDeModulo.forbiddenProps,
};

export const fieldsInfo = {
  ...keysAsEmptyObjects,
  [padronesEnum.CIUDADANO]: ciudadano.fieldsInfo,
  [padronesEnum.EMPRESA]: empresas.fieldsInfo,
  [padronesEnum.PREDIO]: predios.fieldsInfo,
  [padronesEnum.VEHICULO]: vehiculos.fieldsInfo,
  [padronesEnum.HOSPEDAJE]: derivadoEmpresaBase.fieldsInfo,
  [padronesEnum.ARRENDAMIENTO]: derivadoEmpresaBase.fieldsInfo,
  [padronesEnum.NOMINA]: nomina.fieldsInfo,
  [padronesEnum.ALCOHOL]: alcohol.fieldsInfo,
  [padronesEnum.CEDULAR]: cedular.fieldsInfo,
  [padronesEnum.JUEGO_DE_AZAR]: derivadoEmpresaBase.fieldsInfo,
  [padronesEnum.NOTARIO]: derivadoEmpresaBase.fieldsInfo,
  [padronesEnum.CASA_DE_EMPENIO]: derivadoEmpresaBase.fieldsInfo,
  [padronesEnum.AGENCIA]: derivadoEmpresaBase.fieldsInfo,
  [padronesEnum.CONTRIBUYENTE]: contribuyente.fieldsInfo,
  [padronesEnum.MOTOCICLETA]: motocicleta.fieldsInfo,
  [padronesEnum.REMOLQUE]: remolque.fieldsInfo,
  [padronesEnum.POLICIA_ESPECIAL]: policiasEspeciales.fieldsInfo,
  // [padronesEnum.INFRACCIONES]: infracciones.fieldsInfo,
  [padronesEnum.COMERCIO_INFORMAL]: expedienteComercio.fieldsInfo,
  [padronesEnum.MERCADO]: mercado.fieldsInfo,
  [padronesEnum.EXPEDIENTE_LICENCIA_FUNCIONAMIENTO]: expedienteLicenciaFuncionamiento.fieldsInfo,
  [padronesEnum.ZONA_EXCLUSIVA]: zonaExclusiva.fieldsInfo,
  [padronesEnum.EXPEDIENTE_DE_ANUNCIO]: expedienteAnuncio.fieldsInfo,
  [padronesEnum.MULTAS]: multas.fieldsInfo,
  [padronesEnum.VENDEDOR_DE_ALCOHOLES]: derivadoEmpresaBase.fieldsInfo,
  [padronesEnum.RETENEDOR_DE_CEDULA]: derivadoEmpresaBase.fieldsInfo,
  [padronesEnum.RETENEDOR_DE_NOMINA]: derivadoEmpresaBase.fieldsInfo,
  [padronesEnum.MODULOS]: expedienteDeModulo.fieldsInfo,
};

export const tabs = {
  ...keysAsEmptyArray,
  [padronesEnum.CIUDADANO]: ciudadano.tabs,
  [padronesEnum.EMPRESA]: empresas.tabs,
  [padronesEnum.PREDIO]: predios.tabs,
  [padronesEnum.VEHICULO]: vehiculos.tabs,
  [padronesEnum.HOSPEDAJE]: derivadoEmpresaBase.tabs,
  [padronesEnum.ARRENDAMIENTO]: derivadoEmpresaBase.tabs,
  [padronesEnum.NOMINA]: nomina.tabs,
  [padronesEnum.ALCOHOL]: alcohol.tabs,
  [padronesEnum.CEDULAR]: cedular.tabs,
  [padronesEnum.JUEGO_DE_AZAR]: derivadoEmpresaBase.tabs,
  [padronesEnum.NOTARIO]: derivadoEmpresaBase.tabs,
  [padronesEnum.CASA_DE_EMPENIO]: derivadoEmpresaBase.tabs,
  [padronesEnum.AGENCIA]: derivadoEmpresaBase.tabs,
  [padronesEnum.CONTRIBUYENTE]: contribuyente.tabs,
  [padronesEnum.MOTOCICLETA]: motocicleta.tabs,
  [padronesEnum.REMOLQUE]: remolque.tabs,
  [padronesEnum.POLICIA_ESPECIAL]: policiasEspeciales.tabs,
  // [padronesEnum.INFRACCIONES]: infracciones.tabs,
  [padronesEnum.COMERCIO_INFORMAL]: expedienteComercio.tabs,
  [padronesEnum.MERCADO]: mercado.tabs,
  [padronesEnum.EXPEDIENTE_LICENCIA_FUNCIONAMIENTO]: expedienteLicenciaFuncionamiento.tabs,
  [padronesEnum.ZONA_EXCLUSIVA]: zonaExclusiva.tabs,
  [padronesEnum.EXPEDIENTE_DE_ANUNCIO]: expedienteAnuncio.tabs,
  [padronesEnum.MULTAS]: multas.tabs,
  [padronesEnum.VENDEDOR_DE_ALCOHOLES]: derivadoEmpresaBase.tabs,
  [padronesEnum.RETENEDOR_DE_CEDULA]: derivadoEmpresaBase.tabs,
  [padronesEnum.RETENEDOR_DE_NOMINA]: derivadoEmpresaBase.tabs,
  [padronesEnum.MODULOS]: expedienteDeModulo.tabs,
};
